import { AgeRange } from '../../shared/features/charts';

export const DEFAULT_AGE_RANGES: AgeRange[] = [
  { from: 14, to: 18 },
  { from: 19, to: 24 },
  { from: 25, to: 34 },
  { from: 35, to: 44 },
  { from: 45, to: 54 },
  { from: 55, to: 64 },
  { from: 65, to: null },
];
